module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_waso_studio@2x-01a6bb08498afd14d6df3041d364b785.webp";